<template>
  <div class="content">
    <success-snackbar ref="snackbar" />
    <h1 class="page-title">Tuo käyttäjiä</h1>
    <p>
      Tuo käyttäjiä ja päivitä tietoja. Lisää excel-tiedosto alla olevaan
      tiedostokenttään. Tiedoston tulee olla .xlsx- tai .xls-muodossa ja
      sisältää neljä saraketta seuraavassa järjestyksessä: 1. Sukunimi, 2.
      Etunimi, 3. Sähköposti, 4. Käyttäjätunnus.
    </p>
    <div class="upload-div">
      <v-file-input
        accept=".xlsx, .xls"
        variant="outlined"
        class="file-input"
        v-model="file"
      ></v-file-input>
      <v-btn class="button" @click="save()" :disabled="file == undefined">
        Lataa
        <v-icon right>mdi-cloud-upload</v-icon>
      </v-btn>
    </div>
    <p class="error-text">{{ errorText }}</p>
  </div>
</template>

<script setup>
import { ref } from "vue";
import ExcelJS from "exceljs";
import SuccessSnackbar from "../components/SuccessSnackbar.vue";

const emit = defineEmits(["import"]);

const file = ref(null);
const errorText = ref("");
const snackbar = ref(null);

const save = async () => {
  if (!file.value) {
    errorText.value = "Virhe: Tiedosto ei voi olla tyhjä.";
    return;
  }
  if (file.value?.name.endsWith(".xlsx") || file.value?.name.endsWith(".xls")) {
    errorText.value = "";
    try {
      const arrayBuffer = await file.value?.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);
      const worksheet = workbook.worksheets[0];
      emit("import", {
        users: createJsonData(worksheet),
        callbackFn: createSnackbar,
      });
      file.value = null;
    } catch (error) {
      errorText.value = "Virhe: Tiedoston lukemisessa tapahtui virhe.";
    }
  } else {
    errorText.value = "Virhe: Tiedoston tulee olla .xlsx- tai .xls-muodossa";
  }
};

const createJsonData = (worksheet) => {
  const jsonList = [];
  worksheet.eachRow((row, rowNumber) => {
    if (rowNumber === 1) return; // Skip header row
    const rowData = {};
    row.eachCell((cell, colNumber) => {
      // Handle hyperlink objects by extracting the text value
      const cellValue = cell.value;
      if (typeof cellValue === 'object' && cellValue?.text) {
        rowData[`col${colNumber}`] = cellValue.text;
      } else {
        rowData[`col${colNumber}`] = cellValue;
      }
    });
    if (Object.keys(rowData).length > 0) {
      jsonList.push(rowData);
    }
  });
  
  if (!jsonList.length || Object.keys(jsonList[0]).length !== 4) {
    errorText.value = "Virhe: Tiedoston tulee sisältää neljä saraketta.";
    return;
  }
  
  return jsonList.map((json) => {
    // Extract text value from email field if it's a hyperlink object
    const email = typeof json.col3 === 'object' && json.col3?.text
      ? json.col3.text
      : json.col3;

    return {
      name: `${json.col1} ${json.col2}`,
      userName: json.col4,
      email: email,
    };
  });
};

const createSnackbar = (success) => {
  snackbar.value?.show(success);
};
</script>

<style scoped>
.upload-div {
  display: flex;
  padding: 24px 0;
  height: 80px;
  align-items: center;
}

.file-input {
  max-width: 70%;
  margin-top: 32px;
}

.error-text {
  color: crimson;
  font-size: 18px;
  padding-left: 36px;
}
</style>
